import React from 'react';
import EnhancedDeactivatedAccountScreen from './EnhancedDeactivatedAccountScreen';

interface DeactivatedAccountScreenProps {
  deactivatedAt?: string | null;
  deactivationReason?: string | null;
}

const DeactivatedAccountScreen: React.FC<DeactivatedAccountScreenProps> = ({
  deactivatedAt,
  deactivationReason
}) => {
  return (
    <EnhancedDeactivatedAccountScreen
      deactivatedAt={deactivatedAt}
      deactivationReason={deactivationReason}
    />
  );
};

export default DeactivatedAccountScreen;